var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRightCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 261,
    viewBox: "0 0 298 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.291 129.955H74.9863V260.361H149.291V129.955Z",
    fill: "#CAFCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.641 65.2964H0.333984V129.955H149.641V65.2964Z",
    fill: "#CAFCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297.541 129.647H223.909C223.886 112.512 216.054 96.0854 202.131 83.9697C188.207 71.8539 169.329 65.0387 149.639 65.0198V0.946304C231.192 0.946304 297.541 58.6802 297.541 129.647Z",
    fill: "#14F595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightCorner);
export default __webpack_public_path__ + "static/media/top_right_corner.f0a62499d978f33d06dc30304aa9cb68.svg";
export { ForwardRef as ReactComponent };